import { render } from "./LinkFederatedUserPage.vue?vue&type=template&id=bf27e9fe&ts=true"
import script from "./LinkFederatedUserPage.vue?vue&type=script&lang=ts"
export * from "./LinkFederatedUserPage.vue?vue&type=script&lang=ts"

import "./LinkFederatedUserPage.vue?vue&type=style&index=0&id=bf27e9fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__